import type { NavErrorBoundaryConfig } from '../../../ui/types';

interface Props extends Pick<NavErrorBoundaryConfig, 'errorMessages' | 'errorMessageValues'> {}

export function getMessages({ errorMessages, errorMessageValues }: Props): Record<string, any> {
	return errorMessages
		? {
				header: errorMessages.header,
				description: errorMessages.description,
				values: errorMessageValues,
			}
		: {};
}
